import {setIsProcessingCSV, setColumns, setRows} from '../dataImport/index.js'
import {readCSVFile} from '../../../../common/createCSVFile.js'

export const SET_IS_DRAG_HOVER = 'ordoro/ui/dataImport/upload/SET_IS_DRAG_HOVER'
export const SET_ERROR = 'ordoro/ui/dataImport/upload/SET_ERROR'

export function setIsDragHover(value) {
  return {
    type: SET_IS_DRAG_HOVER,
    payload: value,
  }
}

export function setError(value) {
  return {
    type: SET_ERROR,
    payload: value,
  }
}

function cleanColumnNames(columns) {
  return columns.map((column) => column.trim().replace(/\s*\*req/i, ''))
}

function normalizeRowWidth(rows, columns) {
  const columnCount = columns.length

  return rows.map((row) => {
    // Add missing columns
    while (row.length < columnCount) {
      row.push('')
    }

    // Remove extra columns
    row.length = columnCount

    return row
  })
}

function extractColumnsAndRows(data) {
  if (!data || data.length < 2) {
    throw new Error('No data present in file.')
  }

  const columns = cleanColumnNames(data[0])

  const rows = normalizeRowWidth(data.slice(1), columns)

  return {
    columns,
    rows,
  }
}

export function processFiles(files, dispatch) {
  dispatch(setIsProcessingCSV(true))

  return readCSVFile(files)
    .then((data) => extractColumnsAndRows(data))
    .then(({columns, rows}) => {
      dispatch(setColumns(columns))
      dispatch(setRows(rows))
    })
    .catch((error) => dispatch(setError(error.message)))
    .then(() => dispatch(setIsProcessingCSV(false)))
}
